var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 6a1 1 0 1 0-2 0v1h-1a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4h-1V6a1 1 0 1 0-2 0v1h-6zm11 7v-2a2 2 0 0 0-2-2h-1v1a1 1 0 1 1-2 0V9h-6v1a1 1 0 1 1-2 0V9h-1a2 2 0 0 0-2 2v2zM8 15v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8zm5 3c0-.552.384-1 .857-1h4.286c.473 0 .857.448.857 1s-.384 1-.857 1h-4.286c-.473 0-.857-.448-.857-1m.857 3c-.473 0-.857.448-.857 1s.384 1 .857 1h4.286c.473 0 .857-.448.857-1s-.384-1-.857-1z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;